import { ConfirmationModal, ToastMessage } from './model';

export const enum SharedActionTypes {
  SET_CURRENT_USER_INFO = '@@shared/SET_CURRENT_USER_INFO',
  TOGGLE_IS_UI_DISABLED = '@@shared/TOGGLE_IS_UI_DISABLED',
  SET_TOAST_MESSAGE = '@@shared/SET_TOAST_MESSAGE',
  SHOW_CONFIRMATION_MODAL = '@@shared/SHOW_CONFIRMATION_MODAL',
  HIDE_CONFIRMATION_MODAL = '@@shared/HIDE_CONFIRMATION_MODAL',
  CONFIRMATION_MODAL_OK = '@@shared/CONFIRMATION_MODAL_OK',
  CONFIRMATION_MODAL_CANCEL = '@@shared/CONFIRMATION_MODAL_CANCEL',
  BUSINESS_UPDATE = '@@shared/BUSINESS_UPDATE',
  VALIDATE_EMAIL = '@@shared/VALIDATE_EMAIL',
  SET_MOBILE_VIEW = '@@shared/SET_MOBILE_VIEW',
  GET_DOWNLOAD_LINK = '@@overview/GET_DOWNLOAD_LINK',
  GET_DOWNLOAD_LINK_FAIL = '@@overview/GET_DOWNLOAD_LINK_FAIL',
  GET_DOWNLOAD_LINK_SUCCESS = '@@overview/GET_DOWNLOAD_LINK_SUCCESS'
}

export interface SharedState {
  currentLanguage: string;
  currentUser: string;
  firstName: string;
  lastName: string;
  parentPartyDibCode: string;
  parentPartyName: string;
  parentPartyId: number;
  isUIDisabled: boolean;
  toastMessage?: ToastMessage;
  confirmationModal?: ConfirmationModal;
  roles: string[];
  isMobileViewSelected: boolean;
  useMfa: boolean;
  downloadLinks: Record<string, string>;
  error?: string; 
}

export interface NavigationState {
  destination: string | null;
}

export class Currency {
  constructor(
    public amount: number,
    public suffix: string,
    public prefix: string
  ) { }
}

export type SortColumnDirectionType = 'ASC' | 'DESC';
